(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-header"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var drawer = document.querySelector('[data-sd-drawer]');
    if (!drawer) return;
    var opens  = document.querySelectorAll('[data-sd-drawer-open]');
    var closes = drawer.querySelectorAll('[data-sd-drawer-close]');

    function setOpen(state){
      if (state) {
        drawer.setAttribute('data-sd-drawer-open','');
        drawer.setAttribute('aria-hidden','false');
        document.documentElement.style.overflow = 'hidden';
      } else {
        drawer.removeAttribute('data-sd-drawer-open');
        drawer.setAttribute('aria-hidden','true');
        document.documentElement.style.overflow = '';
      }
      opens.forEach(function(o){ o.setAttribute('aria-expanded', state ? 'true' : 'false'); });
    }

    opens.forEach(function(o){ o.addEventListener('click', function(){ setOpen(true); }); });
    closes.forEach(function(c){ c.addEventListener('click', function(){ setOpen(false); }); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') setOpen(false); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-sd-tabs]').forEach(function(root){
      var btns = root.querySelectorAll('.sd-tabs__btn');
      var panes = root.querySelectorAll('.sd-tabs__pane');
      btns.forEach(function(btn){
        btn.addEventListener('click', function(){
          var target = btn.getAttribute('data-sd-tab-target');
          btns.forEach(function(b){ b.classList.remove('is-active'); b.setAttribute('aria-selected','false'); });
          panes.forEach(function(p){ p.classList.remove('is-active'); p.hidden = true; });
          btn.classList.add('is-active'); btn.setAttribute('aria-selected','true');
          var pane = root.querySelector('#' + target);
          if (pane){ pane.classList.add('is-active'); pane.hidden = false; }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-why"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-sd-compare]').forEach(function(root){
      var dragging = false;
      function setPos(pct){
        pct = Math.max(0, Math.min(100, pct));
        root.style.setProperty('--sd-compare-pos', pct + '%');
        root.setAttribute('aria-valuenow', Math.round(pct));
      }
      function fromClientX(clientX){
        var rect = root.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }
      function start(e){
        dragging = true;
        root.classList.add('is-dragging');
        if (e.cancelable) e.preventDefault();
        move(e);
      }
      function move(e){
        if (!dragging) return;
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        setPos(fromClientX(x));
      }
      function end(){
        dragging = false;
        root.classList.remove('is-dragging');
      }
      // Click anywhere on the image to jump
      root.addEventListener('click', function(e){
        if (e.target.closest('[data-sd-compare-handle]')) return;
        setPos(fromClientX(e.clientX));
      });
      // Drag handle (mouse + touch)
      root.addEventListener('mousedown', start);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', end);
      root.addEventListener('touchstart', start, { passive: false });
      window.addEventListener('touchmove', move, { passive: false });
      window.addEventListener('touchend', end);
      // Keyboard
      root.addEventListener('keydown', function(e){
        var cur = parseFloat(root.style.getPropertyValue('--sd-compare-pos')) || 50;
        if (e.key === 'ArrowLeft')  { setPos(cur - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPos(cur + 5); e.preventDefault(); }
        if (e.key === 'Home')       { setPos(0);  e.preventDefault(); }
        if (e.key === 'End')        { setPos(100); e.preventDefault(); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
